import React, { lazy, Suspense, useEffect } from "react"
import "./App.css"
import 'bootstrap/dist/css/bootstrap.min.css'
// import 'bootstrap/dist/js/bootstrap.bundle.min';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { FriendlyUrlComponent } from "./Components"
import { Routes, Route, useLocation } from 'react-router-dom';
import ProtectedRoute from "./Utils/ProtectedRoute"
import Logout from "./Utils/Logout";
import { addWishlist, clearWishlist, fetchProducts } from "./redux/Slices/cartSlice";
import { Provider, useDispatch } from "react-redux";
import { store as bgbStore } from "./redux/Store";
import { ToastContainer } from "react-toastify";
import Blog from "./Components/Footer/Blogs";
import axiosConfig from "./Service/axiosConfig"

const Home = lazy(() => import("./Pages/Home"))
const ProductSearch = lazy(() => import("./Pages/ProductSearch"))
const Brands = lazy(() => import("./Pages/Brands"))
const NotFound = lazy(() => import("./Pages/NotFound"))
const Dashboard = lazy(() => import("./Pages/Dashboard"))
const SearchProducts = lazy(() => import("./Pages/SearchProducts"))
const CategoriesPage = lazy(() => import("./Pages/CategoriesPage"))
const MyAddress = lazy(() => import("./Pages/MyAddress"))
const Wishlistpage = lazy(() => import("./Pages/Wishlistpage"))
const SubCategoriesPage = lazy(() => import("./Pages/SubCategoriesPage"))
const ListingPage = lazy(() => import("./Pages/ListingPage"))
const AboutUs = lazy(() => import("./Components/PrivacyPages/AboutUs"))
const ContuctUs = lazy(() => import("./Components/PrivacyPages/ContuctUs"))
const AccountResp = lazy(() => import("./Components/Navbar/AccountResp"))
const Wallet = lazy(() => import("./Pages/Wallet"))
const MyOrders = lazy(() => import("./Pages/MyOrders"))
const MyOrderDetails = lazy(() => import("./Pages/MyOrderDetails"))
const PaymentGetway = lazy(() => import("./Pages/PaymentGetway"))
const ProductDetailPage = lazy(() => import("./Pages/ProductDetailPage").then(m => ({ default: m.ProductDetailPage })))

function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    dispatch(fetchProducts());
  }, [dispatch]);

  useEffect(() => {
    if (window.gtag) {
      window.gtag('config', 'G-W15NVYHE61', {
        page_path: location.pathname,
      });
    }
  }, [location]);

  // useEffect(() => {
  //   // Find all style tags
  //   const styles = document.querySelectorAll('style');
  //   const body = document.querySelector('body');

  //   // Move all style tags to the bottom of the body
  //   styles.forEach((style) => {
  //     body.appendChild(style); // or append to the head as last child
  //   });
  // }, []);

  useEffect(() => {
    const userId = localStorage.getItem("userId") || localStorage.getItem("userid");
    if (!userId) return;

    dispatch(clearWishlist());

    axiosConfig.get(`/catlog/wishlists/?page_size=100&user=${userId}`)
      .then(res => {
        res.data.results.forEach(item => {
          const wishlistProduct = item.varient || item.product;
          if (!wishlistProduct?.id) return;
          dispatch(addWishlist({
            productId: wishlistProduct.id,
            wish_id: item?.id,
            type: item.type === "rental" || item.type === "rent" ? "rental" : "sale"
          }));
        });
      });
  }, [dispatch]);

  return (
    <div className="app-container">
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path='/' element={<Home />} />
          <Route path="/logout" element={<Logout />} />
          <Route path='/product-search' element={<ProductSearch />} />
          <Route path='/s' element={<SearchProducts />} />
          <Route path='/sale' element={<ListingPage />} />
          <Route path='/rent' element={<ListingPage />} />
          <Route path='/product/:productSlug' element={<ProductDetailPage />} />
          <Route path='/c/:categoryslug' element={<CategoriesPage />} />
          <Route path='/c/:categoryslug/:subcategoryslug' element={<SubCategoriesPage />} />
          <Route path='/:friendlyurl/' element={<FriendlyUrlComponent />} />
          <Route path='/:categoryurl/:friendlyurl/' element={<FriendlyUrlComponent />} />
          <Route element={<ProtectedRoute />} >
            <Route path='/account' element={<AccountResp />} />
            <Route path='/account/addresses' element={<MyAddress />} />
            <Route path='/account/orders' element={<MyOrders />} />
            <Route path='/account/orders/order-details' element={<MyOrderDetails />} />
            <Route path='/account/wallet' element={<Wallet />} />
            <Route path='/checkout' element={<PaymentGetway />} />
          </Route>

          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/blogs" element={<Blog />} />
          <Route path="/aboutus" element={<AboutUs />} />
          <Route path="/contactus" element={<ContuctUs />} />
          <Route path="/brands" element={<Brands />} />
          <Route path="/wishlist" element={<Wishlistpage />} />
          <Route path='/wishlist/:friendlyurl' element={<FriendlyUrlComponent />} />

          <Route
            path='/:categoryurl/:subcategoryurl/:friendlyurl/'
            element={<FriendlyUrlComponent />}
          />
          <Route path='*' element={<NotFound />} />
          <Route path='/not-found' element={<NotFound />} />
        </Routes>
      </Suspense>
      <ToastContainer
        position="top-right"
        autoClose={2200}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover
        theme="light"
        toastClassName="bgb-toast"
        bodyClassName="bgb-toast-body"
        progressClassName="bgb-progress"
      />
    </div>
  );
}

export default function AppWrapper() {
  return (
    <Provider store={bgbStore}>
      <App />
    </Provider>
  );
}
